import { createSelector } from '@reduxjs/toolkit'

const sliceSelector = (state) => state.managedEventTypes.memberships.organizationMemberships

export const isLoadingSelector = createSelector(
  sliceSelector,
  ({ status }) => status === 'loading'
)

export const isLoadedSelector = createSelector(
  sliceSelector,
  ({ status }) => status === 'loaded'
)

export const listSelector = createSelector(
  sliceSelector,
  ({ list }) => list
)
